import { SiteSettings } from 'lib/page-props-factory/plugins/site-settings';
import { Data } from '@generated/Foundation.GMI.model';
import { RecipeFAQProps } from './RecipeFAQ';

/**
 * Extracts FAQ data from a RecipeResponse object
 * @param recipe - The full recipe response object
 * @param siteSettings - Optional site settings for recipe FAQ settings
 * @returns RecipeFAQProps object with only the properties needed for the recipe header
 */
export function extractRecipeFAQData(
  siteSettings?:
    | (SiteSettings & {
        recipeDetailSiteSettings?: Data.Settings.RecipeDetailSiteSettings;
      })
    | null
): RecipeFAQProps {
  const { recipeDetailSiteSettings } = siteSettings || {};
  const faqSettings = {
    hideRecipeFAQ: recipeDetailSiteSettings?.fields?.hideRecipeFAQ?.value,
  };

  return {
    faqSettings: {
      ...faqSettings,
    },
  };
}
